module.exports = __webpack_public_path__ + "static/media/Ø3(3).fb9a82df.png";